import Cookies from 'js-cookie';
import axios from 'axios';
import { getUTMs } from '../../../utils/handleCookies';

const HUBSPOT_API_BASE_URL =
  'https://api.hsforms.com/submissions/v3/integration/submit';
const HUBSPOT_PORTAL_ID = '243522351';

const prepareDemoFormFields = data => {
  const utms = getUTMs();
  const fields = [];

  const fieldMappings = {
    email: 'email',
    firstname: 'firstname',
    lastname: 'lastname',
    phone: 'phone',
    companyname: 'company',
    Number_of_Technicians_Range__c: 'number_of_technicians_range__c',
    industry: 'industry',
    industrydetail: 'industry_detail',
    country: 'country',
    state: 'state',
    url: 'url__c',
    gclid: 'gclid__c',
    language: 'language__cc',
    utm_source: 'utm_source__cc',
    utm_medium: 'utm_medium__cc',
    utm_campaign: 'utm_campaign__cc',
    utm_term: 'utm_term__cc',
    utm_content: 'utm_content__cc',
  };

  const requiredFields = ['email', 'firstname', 'lastname'];

  // First add required fields
  requiredFields.forEach(field => {
    if (data[field]) {
      fields.push({
        name: fieldMappings[field] || field,
        value: data[field].toString(),
      });
    }
  });

  // Then add all other fields that have values
  Object.entries(data).forEach(([field, value]) => {
    // Skip required fields as they're already added
    if (requiredFields.includes(field)) return;

    if (!value || value === '') return;

    const hubspotField = fieldMappings[field] || field;

    fields.push({
      name: hubspotField,
      value: value.toString(),
    });
  });

  if (utms && Object.keys(utms).length > 0) {
    Object.entries(utms).forEach(([utmKey, utmValue]) => {
      if (utmValue && fieldMappings[utmKey]) {
        fields.push({
          name: fieldMappings[utmKey],
          value: utmValue.toString(),
        });
      }
    });
  }

  return fields;
};

export const submitDemoToHubspot = (data, formId) => {
  const utms = getUTMs();

  const mergedData = { ...data, ...utms };
  const fields = prepareDemoFormFields(mergedData);

  const context = {
    hutk: Cookies.get('hubspotutk'),
    pageUri: window.location.href,
    pageName: document.title,
  };

  const payload = {
    fields,
    context,
    submittedAt: Date.now(),
    skipValidation: true,
  };

  const submissionUrl = `${HUBSPOT_API_BASE_URL}/${HUBSPOT_PORTAL_ID}/${formId}`;

  return axios
    .post(submissionUrl, payload, {
      headers: {
        'Content-Type': 'application/json',
      },
    })
    .then(response => {
      console.log('HubSpot submission successful:', response.data);
      return response;
    })
    .catch(error => {
      console.error(
        'HubSpot submission error:',
        error.response ? error.response.data : error.message
      );
      throw error;
    });
};
